<template>
  <v-dialog v-model="show" max-width="800px" persistent>
    <v-card>
      <v-card-title class="headline"> Enviar E-mail </v-card-title>

      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <!--<v-text-field
            v-model="email.from"
            label="De"
            prepend-icon="mdi-account"
            readonly
          />-->

          <v-text-field
            v-model="email.to"
            label="Para"
            prepend-icon="mdi-email-outline"
            :rules="[
              (v) => !v || /.+@.+\..+/.test(v) || 'O Email deve ser válido',
            ]"
          />

          <v-text-field
            v-model="email.cc"
            label="CC"
            prepend-icon="mdi-account-multiple-outline"
            :rules="[
              (v) => !v || /.+@.+\..+/.test(v) || 'O Email deve ser válido',
            ]"
          />
          <v-combobox
            v-model="emailDestinatarios"
            :items="opcoesEmail"
            label="CCO"
            prepend-icon="mdi-email"
            variant="solo"
            chips
            clearable
            closable-chips
            multiple
          >
            <template v-slot:chip="{ props, item }">
              <v-chip v-bind="props" close>
                {{ item.raw }}
              </v-chip>
            </template>
          </v-combobox>
          <v-text-field
            v-model="email.subject"
            label="Assunto"
            prepend-icon="mdi-text-box-outline"
            :rules="[(v) => !!v || 'O campo Assunto é obrigatório']"
          />
          <v-textarea
            v-model="email.body"
            label="Mensagem"
            auto-grow
            rows="4"
            prepend-icon="mdi-pencil"
            :rules="[(v) => !!v || 'O campo Mensagem é obrigatório']"
          />
          <!--<div v-html="html"></div>-->

          <v-file-input
            :value="attachedFile"
            label="Anexo (PDF)"
            prepend-icon="mdi-paperclip"
            readonly
            dense
          >
          </v-file-input>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="cancel">Cancelar</v-btn>
        <v-btn color="primary" @click="sendEmail">Enviar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { integer } from "vuelidate/lib/validators";

export default {
  name: "EmailComposer",
  props: {
    show: Boolean,
    attachedFile: Object, // Ex: { name: 'formulario.pdf', blob: Blob }
    userEmail: String, // Preenche o campo "De"
    produtos: Array,
    fornecedores: Array,
    numeroCotacao: Number,
  },
  data() {
    return {
      valid: false,
      html: null,
      email: {
        from: this.userEmail || "",
        to: "",
        cc: "",
        bcc: "",
        subject: "",
        body: "",
      },
      emailDestinatarios: [], // v-model do combobox
      opcoesEmail: [], // e-mails disponíveis
      emailRule: (v) => !!v || "O campo 'Para' é obrigatório.",
    };
  },
  created: function () {
    //this.email.body = this.gerarTabelaItensHtml(this.produtos);
    this.html = this.gerarTabelaItensHtml(this.produtos);
  },
  watch: {
    // Quando o modal é aberto (show = true), inicializa a lista
    show(val) {
      if (val) {
        this.prepararEmails();
      }
    },
    emailDestinatarios: {
      handler(novaLista) {
        const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const emailsValidos = novaLista.filter((email) =>
          regexEmail.test(email)
        );

        if (emailsValidos.length < novaLista.length) {
          this.$nextTick(() => {
            this.emailDestinatarios = emailsValidos;
            // opcional: feedback visual
            this.$emit(
              "erro-email",
              "Um ou mais e-mails foram removidos por estarem em formato inválido."
            );
          });
        }
      },
      deep: true,
    },
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    gerarTabelaItensHtml(itens) {
      if (!itens || itens.length === 0) return "";

      const headers = Object.keys(itens[0]);

      let html = "<p>Segue abaixo os itens do Mapa de Compra:</p>";
      html +=
        "<table border='1' cellspacing='0' cellpadding='5' style='border-collapse: collapse;'>";
      html += "<thead><tr>";

      headers.forEach((key) => {
        html += `<th style="background:#f0f0f0;">${key}</th>`;
      });

      html += "</tr></thead><tbody>";

      itens.forEach((item) => {
        html += "<tr>";
        headers.forEach((key) => {
          html += `<td>${item[key]}</td>`;
        });
        html += "</tr>";
      });

      html += "</tbody></table><br>";

      return html;
    },
    prepararEmails() {
      const emails = this.fornecedores
        .flatMap((f) =>
          (f.emails || []).filter((e) => e.ativo).map((e) => e.email)
        )
        .filter(Boolean)
        .map((e) => e.trim())
        .filter((email, i, arr) => arr.indexOf(email) === i);

      this.opcoesEmail = emails;
      this.emailDestinatarios = [...emails];
      this.email.subject = "Cotação Nº " + this.numeroCotacao;
    },
    sendEmail() {
      if (!this.$refs.form.validate()) return;

      const fornecedores = this.emailDestinatarios.join(",");

      if (this.email.to != "" || this.email.cc != "" || fornecedores != "") {
        const formData = new FormData();
        formData.append("from", this.email.from);
        formData.append("to", this.email.to);
        formData.append("cc", this.email.cc);
        formData.append("bcc", fornecedores);
        formData.append("subject", this.email.subject);
        formData.append("body", this.email.body);

        if (this.attachedFile && this.attachedFile.blob) {
          formData.append(
            "attachment",
            this.attachedFile.blob,
            this.attachedFile.name
          );
        }
        this.$emit("send", formData);
        this.$emit("cancel");
      } else {
        this.$alert(
          "Informe um endereço de email para envio!",
          "Atenção!",
          "warning"
        );
      }
    },
  },
};
</script>
